module.exports = __webpack_public_path__ + "static/media/kinderen.a2feee86.png";